module.exports = __webpack_public_path__ + "static/media/list.2ee54cc7.svg";